import { h, Fragment } from "preact";
import { Form, Input, Typography, Skeleton } from "antd";
import useProfile from "./useProfile";
import FloatLabel from "./FloatLabel";
import { useEffect, useState } from "preact/hooks";
import axios from "axios";
import './AccountPage.css'

export default function CompanyDataTab() {
    const {profile, isLoading} = useProfile();
    const [companyData, setCompanyData] = useState({
        // organizationType: 'LLP',
        companyName: profile?.company ?? '-',
        // BIN: 12345123,
        // industry: 'Bank',
        country: profile?.country ?? '-',
        // beneficiaryCode: 25,
        // IIC: 43534543,
        // BIC: 'HSBCSN',
        // ZIP: 123123,
        city: profile?.city ?? '-',
        street: profile?.address ?? '-',
        contact_person_email: profile?.contact_person_email ?? '-',
        contact_person_full_name: profile?.contact_person_full_name ?? '-',
        contact_person_phone_number: profile?.contact_person_phone_number ?? '-',
    });

    const handleChange = (name, value) => {
        setCompanyData({ ...companyData, [name]: value });
    };

    const inputFields = [
        // { label: 'Type Of Organization', name: 'organizationType'},
        { label: 'Company Name', name: 'companyName'},
        // { label: 'BIN', name: 'BIN'},
        // { label: 'Industry', name: 'industry'},
        { label: 'Country', name: 'country',  },
        // { label: 'Beneficiary Code', name: 'beneficiaryCode'},
        // { label: 'IIC', name: 'IIC'},
        // { label: 'BIC', name: 'BIC'},
        // { label: 'ZIP', name: 'ZIP'},
        { label: 'City', name: 'city'},
        { label: 'Street', name: 'street'},
        { label: 'Contact email', name: 'contact_person_email'},
        { label: 'Contact full name', name: 'contact_person_full_name'},
        { label: 'Contact phone number', name: 'contact_person_phone_number'},

        // { label: 'Building', name: 'building'},
        // { label: 'Office', name: 'office'},
    ];
    
    const renderInputFields = (inputFields) => {
        return inputFields.map(({ label, name }) => (
            <FloatLabel key={name} label={label} name={name} value={companyData[name]}>
                <Input
                    value={companyData[name]}
                    onChange={(e) => handleChange(name, e.target.value)}
                    readOnly
                />
            </FloatLabel>
        ));
    };

    useEffect(()=>{
        setCompanyData(prevCompanyData => ({
    ...prevCompanyData,
    companyName: profile?.company ?? '-',
    country: profile?.country ?? '-',
    city: profile?.city ?? '-',
    street: profile?.address ?? '-',
    contact_person_email: profile?.contact_person_email ?? '-',
    contact_person_full_name: profile?.contact_person_full_name ?? '-',
    contact_person_phone_number: profile?.contact_person_phone_number ?? '-',
  }));
    }, [profile]);
    
    return (
        <>
        <Skeleton
        loading={isLoading}
        active
        >
            <Typography.Title level={3} style={{ marginBottom: "24px" }}>
                Company Data
            </Typography.Title>
            
            <div style={{
                display: 'flex',
                columnGap: '50px',
                paddingRight: '10%',
                paddingTop: '10px',
            }}>
                <div style={{flex: '1'}}>
                    {renderInputFields(inputFields.slice(0, 4))}
                </div>
                <div style={{flex:'1'}}>
                    {renderInputFields(inputFields.slice(4))}
                </div>
            </div>
        </Skeleton>
        </>
    )
}